@if (timeslot()) {
  <div
    (click)="navigateToBookingUrl(timeslot().routerLink, timeslot().queryParams)"
    class="w-[5.325rem] min-w-[5.325rem] h-[3.673rem] min-h-[3.673rem] p-2 rounded-lg bg-duck-blue-2 hover:bg-duck-blue-1 text-white hover:text-white inline-flex items-center justify-center transition duration-150 ease-in-out flex-col cursor-pointer"
    rel="nofollow"
  >
    <span class="text-base font-bold">{{ timeslot().labelTime }}</span>
    <span class="text-sm">{{ timeslot().labelDay }}</span>
  </div>
}
